import { Directive, HostListener, ElementRef, Input } from "@angular/core";

@Directive({
  selector: "textarea[autoresize]" // Attribute selector
})
export class AutoresizeDirective {

  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    this.adjust();
  }
  
  constructor(public element: ElementRef) {}
  
  ngOnInit(): void {
    this.adjust()
  }
  
  adjust(): void {

    let ta = this.element.nativeElement,
      newHeight;

    if (ta) {

      ta.style.overflow = "hidden"
      ta.style.height = "auto"

      newHeight = ta.scrollHeight
      
      ta.style.height = newHeight + "px"
    }
  }

}